module.exports = __webpack_public_path__ + "static/Windmill-e1e1022ab1a670842088a820f2d01232.mp4";